import makeStyles from '@mui/styles/makeStyles';
import colors from '../../styles/colors';

export const useStyles = makeStyles({
  root: {
    backgroundColor: colors.white,
  },
});
